import { useTranslation } from 'next-i18next';
import React from 'react';
import Tooltip from 'react-tooltip-lite';
import { themeColors } from 'utils/tailwind/tailwindHelpers';

import { Typography } from '@/shared/components/atoms';

import InfoCircle from '~/images/shared/ExleminationMark.svg';

const TableHeader = () => {
  const { t } = useTranslation('common');
  return (
    <div className=' grid grid-cols-12 gap-48 bg-background-neutral-99 px-24 py-12'>
      <Typography variant='caption' weight='semiBold' className='col-span-1'>
        {t('step')}
      </Typography>
      <Typography variant='caption' weight='semiBold' className='col-span-6'>
        {t('approver')}
      </Typography>
      <div className='col-span-3 flex items-center gap-2'>
        <Typography variant='caption' weight='semiBold'>
          {t('can-edit')}
        </Typography>
        <Tooltip
          content={
            <Typography className='py-8 px-16 text-center'>
              {t('edit-authority')}
            </Typography>
          }
          background={themeColors().background['neutral-99']}
          className='react-tooltip-rounded'
          arrow
          arrowSize={10}
          direction='bottom'
          tagName='div'
          tipContentHover
          padding={0}
        >
          <span className='cursor-pointer text-surface-10'>
            <InfoCircle width='16' height='16' />
          </span>
        </Tooltip>
      </div>
      <div className='col-span-2' />
    </div>
  );
};
export default TableHeader;
